import { Routes, Route, Navigate } from 'react-router-dom'
import DocsLayout from '../components/layout/DocsLayout/DocsLayout'
import { VersionProvider } from '../hooks/useVersion'
import DocsContent from '../components/docs/DocsContent'

function DocsPage() {
  return (
    <VersionProvider>
      <Routes>
        {/* Redirect /docs to /docs/latest/en */}
        <Route index element={<Navigate to='latest/en' replace />} />

        {/* Version + language routes */}
        <Route path=':version/:lang' element={<DocsLayout />}>
          <Route index element={<DocsContent docPath='index' />} />
          <Route path='installation' element={<DocsContent docPath='installation' />} />
          <Route path='user-management' element={<DocsContent docPath='user-management' />} />
          <Route path='application-manual' element={<DocsContent docPath='application-manual/index' />} />
          <Route path='application-manual/:section' element={<DocsContent docPath='application-manual' />} />
          <Route path='uninstallation' element={<DocsContent docPath='uninstallation' />} />
        </Route>
      </Routes>
    </VersionProvider>
  )
}

export default DocsPage
